var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-9" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-5" },
            [
              _c(
                "v-select",
                {
                  staticClass: "form-control validate",
                  class: [_vm.showError ? "invalid" : "mb-2"],
                  attrs: {
                    options: _vm.typeOptions,
                    disabled:
                      !_vm.canWrite ||
                      _vm.typeOptions.length === 0 ||
                      _vm.isRequired,
                    clearable: false,
                    searchable: "",
                    filterable: ""
                  },
                  model: {
                    value: _vm.typeModel,
                    callback: function($$v) {
                      _vm.typeModel = $$v
                    },
                    expression: "typeModel"
                  }
                },
                [
                  _c("div", {
                    attrs: { slot: "no-options" },
                    slot: "no-options"
                  })
                ]
              ),
              _vm._v(" "),
              _vm.isRequired
                ? _c("span", { staticClass: "required" }, [_vm._v("*")])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-7" },
            [
              _vm.isDropdown
                ? _c(
                    "v-select",
                    {
                      staticClass: "form-control validate",
                      class: [_vm.showError ? "invalid" : ""],
                      attrs: {
                        options: _vm.dropdownOptions,
                        disabled:
                          !_vm.canWrite || _vm.dropdownOptions.length === 0,
                        clearable: false,
                        searchable: "",
                        filterable: ""
                      },
                      on: { "search:blur": _vm.triggerValidation },
                      model: {
                        value: _vm.dropdownValueModel,
                        callback: function($$v) {
                          _vm.dropdownValueModel = $$v
                        },
                        expression: "dropdownValueModel"
                      }
                    },
                    [
                      _c("div", {
                        attrs: { slot: "no-options" },
                        slot: "no-options"
                      })
                    ]
                  )
                : _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.valueModel,
                        expression: "valueModel"
                      }
                    ],
                    staticClass: "form-control validate",
                    class: [_vm.showError ? "invalid" : ""],
                    attrs: { type: "text", disabled: !_vm.canWrite },
                    domProps: { value: _vm.valueModel },
                    on: {
                      blur: _vm.triggerValidation,
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.valueModel = $event.target.value
                      }
                    }
                  })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-3" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-outline-danger pull-right",
            attrs: { disabled: !_vm.canWrite || _vm.isRequired },
            on: {
              click: function($event) {
                return _vm.$emit("delete", _vm.value.id)
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-trash" }),
            _vm._v(
              " " + _vm._s(_vm.resource("Button_Remove")) + "\n            "
            )
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _vm.showError
      ? _c("div", { staticClass: "row mb-2" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            _vm._l(_vm.errors, function(message) {
              return _c("error-message", {
                key: message,
                attrs: { message: message }
              })
            }),
            1
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }